import { TextLink } from '@bfe/moly';
import { FC } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useI18nContext } from '@/i18n/I18n';
import { SubMemberType } from '@/utils/constants/sub-account';
import {
  navigateToAPiEditPage,
  navigateToSubAccountEditApiPage,
} from '@/utils/navigateTo';

interface EditApiBtnProps {
  /** 列表返回的id */
  apiManagementId: string;
  subAccountId: string;
  isFromSubAccount: boolean;
  hasGoogle2fa: () => boolean;
  isCopperSubAccount: boolean;
  disabled?: boolean;
}

export const EditApiBtn: FC<EditApiBtnProps> = (props) => {
  const [$t] = useI18nContext();
  const navigate = useNavigate();

  const [search] = useSearchParams();
  const name = search.get('name');
  const memberType = search.get('memberType');
  const memberStatus = search.get('memberStatus') || '';
  const subAccountMemberTag = search.get('member_tag') || '';

  const {
    apiManagementId,
    isFromSubAccount,
    subAccountId,
    hasGoogle2fa,
    disabled,
    isCopperSubAccount,
  } = props;

  const editNewKey = () => {
    if (!hasGoogle2fa()) {
      return;
    }
    if (isFromSubAccount) {
      navigateToSubAccountEditApiPage({
        subAccountId,
        subAccountLoginName: name || '',
        subAccountMemberTag: isCopperSubAccount
          ? `${subAccountMemberTag},copper`
          : subAccountMemberTag,
        subAccountMemberType: memberType as SubMemberType,
        subAccountMemberStatus: memberStatus,
        apiManagementId,
      });
      return;
    }
    navigateToAPiEditPage({ apiManagementId, navigate });

    // mzry TODO: 是否添加埋点
    // $tracing.addEvent({
    //   t: 'action',
    //   c: 15104,
    // });
  };
  return (
    <TextLink
      variant="primary"
      size="normal"
      onClick={editNewKey}
      closeIcon
      style={{ width: 'max-content' }}
      disabled={disabled}
    >
      {$t('apiEditAction')}
    </TextLink>
  );
};
